import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "./auth"
import axiosAuthRequired from "./axiosAuthRequired"

/**
 * Game Resources
 */

export const fetchVersion = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/super-smash-bros-ultimate/static-data/version",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchCharacters = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-resources/super-smash-bros-ultimate/static-data/characters",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchCharacterById = id => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      `api/v2/game-resources/super-smash-bros-ultimate/static-data/characters/by-id/${id}`,
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchCharacterByKey = key => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      `api/v2/game-resources/super-smash-bros-ultimate/static-data/characters/by-key/${key}`,
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const fetchCharacterGuidesByCharacterKey = key => {
  return axiosAuthRequired({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      `api/v2/game-resources/super-smash-bros-ultimate/characters/${key}/video-guides`,
    headers: getAuthHeaders(),
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * Game Meta
 */

export const fetchTierList = () => {
  return axios({
    method: "get",
    url:
      process.env.PROGUIDES_WEB_URL +
      "api/v2/game-meta/super-smash-bros-ultimate/characters/tier-list",
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/ssbu.js